var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SearchSelect',{attrs:{"label":"Rolle","val":_vm.val,"items":_vm.vm.roleSelectionList,"loading":_vm.vm.loadResponse.loading,"disabled":_vm.disabled,"error":_vm.vm.loadResponse.error,"hideDetails":_vm.hideDetails,"dense":_vm.dense},on:{"change":function($event){return _vm.emitSelect($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }